import { render, staticRenderFns } from "./DesktopIcon.vue?vue&type=template&id=7f636c73&"
import script from "./DesktopIcon.vue?vue&type=script&lang=js&"
export * from "./DesktopIcon.vue?vue&type=script&lang=js&"
import style0 from "./DesktopIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports